import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { Store } from '@ngxs/store';
import {
  ActivateUserAsProductOwner,
  DeactivateUserAsProductOwner,
} from 'src/app/shared/user-view/state/user.actions';

@Component({
  selector: 'app-product-owner-users-template',
  templateUrl: './product-owner-users-template.component.html',
  styleUrls: ['./product-owner-users-template.component.scss'],
  standalone: false,
})
export class ProductOwnerUsersTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;
  showIcon: boolean;
  actions = [ActivateUserAsProductOwner, DeactivateUserAsProductOwner];
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.showIcon = ['deleted', 'isProductOwner'].includes(this.columnName);
  }

  setActivationStatus(event?: Event): void {
    event?.stopPropagation();
    this.store.dispatch(
      this.element.isActive
        ? new DeactivateUserAsProductOwner(this.element.id)
        : new ActivateUserAsProductOwner(this.element.id)
    );
  }
}
